import messages_en from './assets/locale/messages_en.json';
import { getCouponSubtitle } from './getCouponSubtitle';
const DEFAULT_LANGUAGE = 'en';
const NAMESPACE = 'translation';
export const loadLoyaltyCouponNames = async ({ i18n, ...otherParams }) => {
    try {
        const { language } = i18n;
        i18n.addResources(DEFAULT_LANGUAGE, NAMESPACE, messages_en);
        if (language !== DEFAULT_LANGUAGE) {
            const res = await import(`./assets/locale/messages_${language}.json`);
            i18n.addResources(language, NAMESPACE, res);
        }
    }
    catch (e) { }
    const t = i18n.getFixedT(null, NAMESPACE);
    const context = {
        ...otherParams,
        t,
    };
    return {
        getCouponSubtitle: getCouponSubtitle.bind(undefined, context),
    };
};
//# sourceMappingURL=loadLoyaltyCouponNames.js.map